import * as React from 'react'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { Typography, Box } from '@mui/material'
import Markdown from 'react-markdown'
import CodeBlock from './CodeBlock'
import PresentationViewer from './PresentationViewer'

const Page = () => {
  const doc = useParams().doc
  const notes = useSelector(state => state.data.notesMap)
  if (!notes || !notes[doc]) {
    return <div />
  }
  const note = notes[doc]
  const title = note.name
  const date = note.date
  const type = note.type || 'markdown'
  const content = note.content || ''

  if (type === 'presentation') {
    return (
      <PresentationViewer
        date={date}
        slides={note.slides || []}
      />
    )
  }

  return (
    <div>
      <Box sx={{
        justifyItems: 'center',
        marginBottom: '1rem',
        borderBottom: '1px solid darkgrey',
      }}>
        <Typography component="h1" sx={{
          margin: 0,
          fontSize: '1.5em',
          fontWeight: 'bold',
        }}>{title}</Typography>
        <Typography sx={{
          fontSize: '10px',
          lineHeight: '17px',
          color: 'darkgrey',
          fontFamily: 'var(--font-sans)',
          whiteSpace: 'nowrap',
        }}>{date}</Typography>
      </Box>
      <Markdown
        components={{
          h1: ({ node, children, ...props }) => (
            <h1
              {...props}
              style={{
                margin: '0 0 20px',
                fontSize: '1.5em',
                fontWeight: 'bold',
                borderBottom: '1px solid #CCC'
              }}
            >
              {children}
            </h1>
          ),
          h2: ({ node, children, ...props }) => (
            <h2
              {...props}
              style={{
                margin: '0 0 20px',
                fontSize: '1.5em',
                borderBottom: '1px solid #CCC',
                fontWeight: 'bold'
              }}
            >
              {children}
            </h2>
          ),
          h3: ({ node, children, ...props }) => (
            <h3
              {...props}
              style={{
                margin: '0 0 20px',
                fontSize: '18px',
                borderBottom: '1px solid #CCC',
                fontWeight: 'bold'
              }}
            >
              {children}
            </h3>
          ),
          h4: ({ node, children, ...props }) => (
            <h4
              {...props}
              style={{
                margin: '0 0 20px',
                fontSize: '1.17em',
                fontWeight: 'bold',
                borderBottom: '1px solid #CCC'
              }}
            >
              {children}
            </h4>
          ),
          h5: ({ node, children, ...props }) => (
            <h5
              {...props}
              style={{
                margin: '0 0 20px',
                fontSize: '1em',
                fontWeight: 'bold',
                borderBottom: '1px solid #CCC'
              }}
            >
              {children}
            </h5>
          ),
          h6: ({ node, children, ...props }) => (
            <h6
              {...props}
              style={{
                margin: '0 0 20px',
                fontSize: '0.83em',
                fontWeight: 'bold',
                borderBottom: '1px solid #CCC'
              }}
            >
              {children}
            </h6>
          ),
          p: ({ node, children, ...props }) => (
            <p
              {...props}
              style={{ lineHeight: '1.5', marginTop: '0px' }}
            >
              {children}
            </p>
          ),
          blockquote: ({ node, children, ...props }) => (
            <blockquote
              {...props}
              style={{
                backgroundColor: 'grey',
                border: 'dashed 1px white',
                width: '97.5%',
                fontStyle: 'italic',
                textAlign: 'justify',
                padding: '2ch 1ch',
                margin: '0 0 2ch 0',
                color: 'var(--fg3)',
                fontSize: '13px',
                lineHeight: 1.4,
                fontWeight: 400,
                letterSpacing: 0
              }}
            >
              {children}
            </blockquote>
          ),
          a: ({ node, children, ...props }) => (
            <a
              {...props}
              style={{ color: '#74c0fc' }}
            >
              {children}
            </a>
          ),
          code({ inline, className, children, ...props }) {
            if (inline) {
              return (
                <code
                  {...props}
                  style={{
                    fontSize: '0.95em',
                    padding: '0.1rem 0.3rem',
                    borderRadius: 4,
                    background: 'rgba(127,127,127,0.12)'
                  }}
                >
                  {children}
                </code>
              )
            }
            return <CodeBlock className={className}>{children}</CodeBlock>
          }
        }}
      >
        {content}
      </Markdown>
    </div>
  )
}

export default Page
